import {HashRouter as Router, Switch, Route} from 'react-router-dom'
import AdminPage from './pages/admin'
import FrontendPage from './pages/frontend'
import FrontendMobilePage from './pages/frontendMobile'
import Preview from './pages/preview'
import PrintPage from './pages/print'
import GraphicsPage from './pages/graphics'
import './css/_global.css'
import {initI18n} from './i18n/i18n'
import {currentLang} from './utils/helpers/currentLang'

initI18n(currentLang())

function App() {
  return (
    <Router hashType="noslash">
      <Switch>
        <Route path="/admin/:productId">
          <AdminPage />
        </Route>
        <Route path="/frontend">
          <FrontendPage />
        </Route>
        <Route path="/frontend-mobile">
          <FrontendMobilePage />
        </Route>
        <Route path="/preview/:productId/:id">
          <Preview />
        </Route>
        <Route path="/print/:productId/:id">
          <PrintPage />
        </Route>
        <Route path="/graphics/:graphicId">
          <GraphicsPage />
        </Route>
      </Switch>
    </Router>
  )
}

export default App
